import {
  AmpLabeledStimuliPoolInput,
  BlockType,
  CategoryVariant,
  CreateAmpTestInput,
  MediaItemSnapshotScope,
  OptionsPosition,
  TestStatus,
  TextAlignment,
} from '../../../../API';
import {
  createDefaultFontStyle,
  createDefaultStyle,
  createEmptyKeyboardSettings,
  createEmptyMediaItemSnapshot,
} from '../../testAdmin/testEditor/initialEditorStates';
import { Amp } from '../types';
import ampTemplateStore from './templates/amp-templates';

const createEmptyCategories = (): AmpLabeledStimuliPoolInput[] => [
  {
    label: '',
    practiceStimuliPool: [],
    testStimuliPool: [],
  },
];

export const ampTemplates: Amp[] = ampTemplateStore;

const InitialAmpEditorState: CreateAmpTestInput = {
  startLabel: 'Start',
  nextLabel: 'Next',
  finishLabel: 'Finish',
  name: '',
  description: '',
  instructions: {
    desktop: '',
  },
  fixation: {
    interval: 500,
    mediaItem: {
      id: '',
      scope: MediaItemSnapshotScope.PRIVATE,
      tags: [],
    },
  },
  primes: {
    interval: 75,
    categories: createEmptyCategories(),
  },
  targets: {
    interval: 200,
    categories: createEmptyCategories(),
  },
  attributeCategories: {
    fontStyle: createDefaultFontStyle(TextAlignment.CENTER),
    categoryA: createEmptyMediaItemSnapshot(),
    categoryB: createEmptyMediaItemSnapshot(),
  },
  mask: createEmptyMediaItemSnapshot(),
  blocks: [
    {
      index: 0,
      name: 'Practice Block',
      amountTrials: 20,
      attributeVariant: CategoryVariant.DEFAULT,
      instructions: {
        desktop: '',
      },
      type: BlockType.PRACTICE,
    },
    {
      index: 1,
      name: 'Test Block',
      amountTrials: 40,
      attributeVariant: CategoryVariant.DEFAULT,
      instructions: {
        desktop: '',
      },
      type: BlockType.NON_PRACTICE,
    },
  ],
  keyboard: createEmptyKeyboardSettings(),
  style: { ...createDefaultStyle(), optionsPosition: OptionsPosition.BOTTOM },
  blankInterval: 100,
  interTrialInterval: 500,
  counterbalancing: false,
  probabilityWithoutReplacement: true,
  status: TestStatus.DRAFT,
};

export default InitialAmpEditorState;
